import React, { Component } from 'react'
import './App.css'
import './Register.css'
import { Link } from 'react-router-dom'
import { IoMdPerson, IoMdBriefcase } from 'react-icons/io'
import { FaHandshake } from 'react-icons/fa'
import { API_URL } from './config'

class Register extends Component {
  componentDidMount() {
    document.title = 'Registration - Choose account'
  }

  render() {
    return (
      <div className="kx-register-page">
        <div className="kx-register-bg">
          <div className="kx-register-bg__orb kx-register-bg__orb--one" />
          <div className="kx-register-bg__orb kx-register-bg__orb--two" />
          <div className="kx-register-bg__grid" />
          <div className="kx-register-bg__word">KARAMALE</div>
        </div>

        <main className="kx-register">
          <div className="kx-register__wrap">
            {/* LEFT BRAND PANEL */}
            <section className="kx-register__brand">
              <Link to="/" className="kx-register__logo">
                karamale<span>.</span>
              </Link>

              <div className="kx-register__brand-content">
                <span className="kx-register__eyebrow">JOIN KARAMALE</span>

                <h1>
                  Your next
                  <strong> event </strong>
                  starts here.
                </h1>

                <p>
                  Whether you're here to discover events, sell tickets, or grow your audience,
                  there's a place for you on Karamale.
                </p>

                <div className="kx-register__brand-points">
                  <div className="kx-register__brand-point">
                    <span>01</span>
                    <div>
                      <strong>Discover events</strong>
                      <small>Find experiences worth showing up for.</small>
                    </div>
                  </div>

                  <div className="kx-register__brand-point">
                    <span>02</span>
                    <div>
                      <strong>Buy tickets</strong>
                      <small>Simple, secure ticketing for every event.</small>
                    </div>
                  </div>

                  <div className="kx-register__brand-point">
                    <span>03</span>
                    <div>
                      <strong>Build your audience</strong>
                      <small>Create and manage your own events.</small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="kx-register__brand-footer">
                Already have an account?
                <Link to="/login">Log in</Link>
              </div>
            </section>

            {/* ACCOUNT SELECTION */}
            <section className="kx-register__panel">
              <div className="kx-register__card">
                <div className="kx-register__card-head">
                  <span className="kx-register__card-kicker">GET STARTED</span>

                  <h2>Choose your account</h2>

                  <p>Select the option that best describes what you want to do on Karamale.</p>
                </div>

                <div className="kx-register__options">
                  <Link to="/customer-registration" className="kx-register__option">
                    <div className="kx-register__option-icon">
                      <IoMdPerson />
                    </div>

                    <div className="kx-register__option-content">
                      <span className="kx-register__option-label">FOR ATTENDEES</span>

                      <h3>Ticket buyer</h3>

                      <p>
                        Discover events and purchase tickets for experiences you don't want to miss.
                      </p>
                    </div>

                    <span className="kx-register__option-arrow">→</span>
                  </Link>

                  <Link to="/organiser-registration" className="kx-register__option">
                    <div className="kx-register__option-icon">
                      <IoMdBriefcase />
                    </div>

                    <div className="kx-register__option-content">
                      <span className="kx-register__option-label">FOR ORGANISERS</span>

                      <h3>Event organiser</h3>

                      <p>Create events, sell tickets and manage your audience from one platform.</p>
                    </div>

                    <span className="kx-register__option-arrow">→</span>
                  </Link>

                  <Link to="/affiliate-registration" className="kx-register__option">
                    <div className="kx-register__option-icon">
                      <FaHandshake />
                    </div>

                    <div className="kx-register__option-content">
                      <span className="kx-register__option-label">FOR PARTNERS</span>

                      <h3>Affiliate</h3>

                      <p>Partner with Karamale and earn by helping events reach more people.</p>

                      <span className="kx-register__learn">Learn more</span>
                    </div>

                    <span className="kx-register__option-arrow">→</span>
                  </Link>
                </div>

                <div className="kx-register__card-footer">
                  <Link to="/">← Back to Karamale</Link>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
    )
  }
}

export default Register
